import { useAuth } from "../context/AuthContext";

export default function AdminLogin() {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const login = () => {
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#2D372B] px-6">
      <div className="bg-[#FAF8F5] rounded-sm border border-[#E6DFD3] max-w-md w-full p-10 text-center">
        <p className="kicker">Wayside Orchard</p>
        <h1 className="font-serif text-4xl text-[#2D372B] mt-2 tracking-tight">Store Admin</h1>
        <p className="text-[#7C897B] mt-4 leading-relaxed">
          Sign in to manage orders, products and your storefront.
        </p>
        <button
          onClick={login}
          data-testid="google-login-button"
          className="mt-8 w-full bg-[#B85C38] hover:bg-[#9A4A2B] text-white uppercase tracking-widest text-sm py-4 transition-colors rounded-sm"
        >
          Sign in with Google
        </button>
      </div>
    </div>
  );
}
